import Modal from "react-modal";
import React, {useEffect, useState} from "react";

import './Team.programs.dialog.scss';
import {Subject} from "rxjs";
import {useLazyQuery, useMutation} from "@apollo/client";
import gqlSchemaLibrary from "../../services/graphql.schemas";
import {useTranslation} from "react-i18next";
import {ModalLog} from "../../services/interactions/elements/modal";
import AuditTrail from "../../services/interactions/audit.trail";
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};
Modal.setAppElement('#root');

function TeamProgramItem({program, onSelected}) {

    const handleClick = () => {
        onSelected(program);
    }

    return (
        <div className={`ProgramItem`} onClick={handleClick}>
                <p className="ellipsis">
                    {program.name}
                </p>
            </div>
    );
}

const _Modal = ModalLog(Modal);

function TeamProgramsDialog({event, team, teams, openModal, closeModal}) {
    const {t} = useTranslation(['common','teams']);
    const [__submitting, __setSubmitting] = useState(false);
    const [programs, setPrograms] = useState([]);
    const [programsSelected, setProgramsSelected] = useState([]);

    const [searchFocused, changeSearchFocused] = useState(false);
    const [search, changeSearch] = useState('');
    const [searchTerm] = useState(new Subject());

    const [getPrograms] = useLazyQuery(gqlSchemaLibrary.programs.query.getCurrentOrgPrograms, {
        onCompleted: (data) => {
            const _programs = programs;
            const _programsSelected = programsSelected;
            for (const p of data.getCurrentOrgPrograms) {
                const d = {
                    _id: p._id,
                    name: p.name
                };
                _programs.push(d);
                if (team && team.programs.find(_p => _p._id === p._id)) {
                    _programsSelected.push(d);
                }
            }
            setProgramsSelected(Object.assign([], _programsSelected));
            setPrograms(Object.assign([], _programs));
        },
        fetchPolicy: 'cache-and-network'
    })

    const [editPrograms] = useMutation(gqlSchemaLibrary.teams.mutation.editPrograms, {
        onCompleted: ({ data }) => {
            __setSubmitting(false);
            closeModal(team? [team] : teams, Object.assign([], programsSelected));
        },
        onError: (e) => {
            console.error('Rename Team Error: ', e);
            __setSubmitting(false);
        }
    });

    useEffect(() => {
        changeSearch('')
        searchTerm.next('');
        setProgramsSelected([]);
        setPrograms([]);
        if (team || teams.length) {
            getPrograms({});
        }
    }, [team, openModal, getPrograms])

    const closeModalEmpty = () => {
        AuditTrail.sendLog(event, {tag: 'button', event: 'closeModal', action: 'button modal programs', value: search, team_id: team._id});
        closeModal();
    }

    const handleFocus = (bool) => {
        return () => {
            changeSearchFocused(bool);
        }
    }

    const handleSearch = (e) => {
        const value = e.target.value;
        changeSearch(value)
        searchTerm.next(value);
    }

    const onSelected = (program) => {
        const index = programsSelected.indexOf(program);
        if (index === -1) {
            programsSelected.push(program);
        }
        setProgramsSelected(Object.assign([], programsSelected));
    }

    const filteredPrograms = programs.filter(t => {
        if (programsSelected.find((m) => m._id === t._id)) {
            return false;
        }
        if (!search) {
            return true;
        }
        const name = (t.name || '').toLowerCase();
        return name.includes(search.toLowerCase());
    }).sort((a, b) => {
        return a.name.localeCompare(b.name);
    })

    const onDeleteItem = (member) => {
        const index = programsSelected.indexOf(member);
        if (index > -1) {
            programsSelected.splice(index, 1);
        }
        setProgramsSelected(Object.assign([], programsSelected));
    }

    const onSave = () => {
        if (__submitting) {
            return;
        }
        __setSubmitting(true);
        const teamIds = team? [team._id] : teams.map((t) => t._id);
        editPrograms({
            variables: {
                teamIds: teamIds,
                programIds: programsSelected.map((p) => p._id)
            }
        });
    }

    const getName = () => {
        if (team) {
            return (
                <>
                    {t('add')} <b>{team.name}</b> {t('teams:to-programs')}
                </>
            );
        }
        return (
            <>
                {t('add')} <b>{teams.length}</b> {t('teams:team')}{teams.length===1?'':'s'} {t('teams:to-programs')}
            </>
        );
    }

    return (
        <_Modal
        isOpen={!!openModal}
        style={customStyles}
        onRequestClose={closeModalEmpty}
        contentLabel="Add programs to team"
        label="ProgramsDialog"
        event={event}
        eventParams={{teamIds: team? [team._id] : teams.map((t) => t._id)}}>
            <div id="ProgramsDialog">
                <div className="__MembersTitle">
                    <i className="material-icons" onClick={closeModalEmpty}>arrow_back_ios</i>
                    <h3>{getName()}</h3>
                </div>
                <div className="__Container">
                    <p className="__MembersSubTitle">
                        {t('teams:select-programs-to-add')}
                    </p>
                    <div className="tags">
                        {
                            programsSelected.map((member, index) => (
                                <span key={'s-'+index} className="selectedMember">
                                    {member.name}
                                    <i className="material-icons" onClick={() => onDeleteItem(member)}>close</i>
                                </span>
                            ))
                        }
                    </div>
                    <div className="InputComponent">
                        <input value={search} placeholder={t('teams:find-a-program-organization')} required={false} onChange={handleSearch}
                           onFocus={handleFocus(true)} onBlur={handleFocus(false)}/>
                    </div>
                    <div className="__ProgramsList">
                        <div className="headers">
                            <div className="selectable">
                                <p>
                                    {t('name')}
                                </p>
                            </div>
                        </div>
                        {
                            filteredPrograms.map((program, index) => (
                                <TeamProgramItem key={index} program={program} onSelected={onSelected} />
                            ))
                        }
                    </div>
                    <div className="containerButtons">
                        <button className="primary gray" onClick={closeModalEmpty}>
                            {t('cancel')}
                        </button>
                        <button className="primary green" onClick={onSave}>
                            {t('add')}
                        </button>
                    </div>
                </div>
            </div>
        </_Modal>
    );
}

export default TeamProgramsDialog;
